import React from 'react'

export const ShieldCheck = props => (
  <svg
    width={48}
    height={48}
    viewBox='0 0 48 48'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path 
        fill-rule="evenodd" 
        clip-rule="evenodd"
        d="M22.5956 4.39066C23.3878 4.09354 24.2509 4.0564 25.0609 4.27924L25.4044 4.39066L39.4044 9.64066C40.8617 10.1871 41.8598 11.5236 41.9864 13.055L42 13.386V24.1114C42 30.7289 38.3713 36.7949 32.582 39.934L32.0498 40.2112L25.3416 43.5652C24.5908 43.9407 23.722 43.9824 22.9451 43.6904L22.6584 43.5652L15.9502 40.2112C10.0314 37.2517 6.22853 31.2933 6.00996 24.7114L6 24.1114V13.386C6 11.8298 6.90099 10.4259 8.29044 9.76962L8.5955 9.64066L22.5956 4.39066ZM30.8658 17.2582L21.6696 26.4544L18.1341 22.9188C17.3531 22.1378 16.0868 22.1378 15.3057 22.9188C14.5247 23.6998 14.5247 24.9662 15.3057 25.7472L20.114 30.5556C20.9732 31.4148 22.3662 31.4148 23.2254 30.5556L33.6942 20.0866C34.4754 19.3056 34.4754 18.0392 33.6942 17.2582C32.9132 16.4771 31.647 16.4771 30.8658 17.2582Z"
    />
  </svg>
)
